export default{
    apiKey: "AIzaSyArzS8YrJeEYGVYMvTf6uFaSHFr3WqFe3Q",
    authDomain: "vue-employee-ae1d3.firebaseapp.com",
    databaseURL: "https://vue-employee-ae1d3.firebaseio.com",
    projectId: "vue-employee-ae1d3",
    storageBucket: "vue-employee-ae1d3.appspot.com",
    messagingSenderId: "366816546506"
}


// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js